import { NumericFormat } from 'react-number-format';
import React, { useState } from 'react';

export function numbersOnly(target) {
  return target.value.replace(/[^\d.]/g, '');
}

const NumberFormatInput = ({ inputRef, onChange, onBlur, name, id, ...other }, decimalScale, temporaryDecimals) => {
  let [showDecimals, setShowDecimals] = useState(false);
  let [intermediateValue, setIntermediateValue] = useState(other.value);

  function numbersOnly(target) {
    return target.value.replace(/[^\d.]/g, '');
  }

  const generateSyntheticEvent = (name, target, relatedTarget) => {
    //TextMask is adding commas and a $ which need to be removed
    const unmaskedValue = temporaryDecimals ? `${Math.round(parseFloat(numbersOnly(target)))}` : numbersOnly(target);

    return {
      maskedValue: target.value,
      unmaskedValue,
      target,
      currentTarget: target,
      relatedTarget,
      persist: () => {},
    };
  };

  return (
    <NumericFormat
      {...other}
      id={id}
      getInputRef={inputRef}
      onChange={(e) => {
        onChange(generateSyntheticEvent(name, e.target, e?.relatedTarget));
        setIntermediateValue(numbersOnly(e.target));
      }}
      onBlur={(e) => {
        setShowDecimals(false);
        if (temporaryDecimals) {
          setIntermediateValue(Math.round(numbersOnly(e.target)));
        }
        onBlur(generateSyntheticEvent(name, e.target, e?.relatedTarget));
      }}
      onKeyDown={(e) => {
        if (e.key === '.' && temporaryDecimals) {
          setShowDecimals(true);
        }
      }}
      value={temporaryDecimals ? intermediateValue : other.value}
      prefix="$"
      thousandSeparator
      valueIsNumericString
      decimalScale={showDecimals ? 2 : decimalScale}
      fixedDecimalScale
      allowNegative={false}
      style={{ backgroundColor: 'white' }}
    />
  );
};

export default NumberFormatInput;
